export default __webpack_public_path__ + "static/media/diamond_video2.3f8c9e18.png";